var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-request-offer"},[_c('MoleculesProjectMoleculeDownloadBrochure')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }